<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-file-text-o"></span>Quotes list</div>

  </div>
  <div class="content">

    <div class="row" style="padding-top: 20px;">
      <div class="col-md-12">
        <p-table #jobCardsTable [columns]="columns" [value]="quotes">
          <ng-template pTemplate="caption">
            <div class="p-inputgroup">
              <input type="text" pInputText size="50" placeholder="{{ 'general.search' | translate }}"
                     (input)="jobCardsTable.filterGlobal($event.target['value'] , 'contains')"
                     style="margin-left: auto;width:auto"/>
              <span class="p-inputgroup-addon"><i class="hubtiger-search"></i></span>
            </div>
          </ng-template>

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
                {{ col.header }}
                <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                            *ngIf="col.type !== 'action'">
                </p-sortIcon>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-claim let-columns="columns">
            <tr [pSelectableRow]="claim">
              <td *ngFor="let col of columns">

                <div *ngIf="col.type !== 'action' && col.type === 'string'">
                  {{
                  col.type === "date"
                    ? (claim[col.field] | date: "dd MMM yyyy")
                    : claim[col.field]
                  }}
                </div>
                <div *ngIf="col.type === 'action'" style="display: grid;">
                  <div class="row">
                    <!--<div class="col-md-6"><button pButton type="button" class="p-button-raised icon" label=" Quote  " (click)="showQuotes(claim[col.field])" icon="pi pi-spin pi-spinner" iconPos="right" aria-hidden="true"></button></div>-->
                    <!--<div class="col-md-1"><i class="pi pi-file" style="font-size: 2em; cursor:pointer;" (click)="showQuotes(claim[col.field])"></i></div>-->
                    <div *ngIf="claim['UnreadMessages'] > 0">
                      <div class="col-md-1"><i class="hubtiger-message-template"
                                               style="font-size: 24pxem; cursor:pointer; color:#EE3158;"
                                               (click)="showMessages(claim[col.field])"></i></div>
                    </div>
                    <div *ngIf="claim['UnreadMessages'] == 0">
                      <div class="col-md-1"><i class="hubtiger-message-template"
                                               style="font-size: 24px; cursor:pointer;"
                                               (click)="showMessages(claim[col.field])"></i></div>
                    </div>
                    <!--<div class="col-md-6"><button pButton type="button" class="p-button-raised icon" label="Message"(click)="showMessages(claim[col.field])" icon="pi pi-spin pi-spinner" iconPos="right"></button></div>-->
                  </div>
                </div>

              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>

  </div>
</div>


<p-sidebar #NavSideBar [(visible)]="showMessage" position="right" [baseZIndex]="10000"
           (onHide)="RefreshQuotes(); NavSideBar.destroyModal()">

  <div class="container-fluid">
    <div class="header-container" style="margin-right: 32px;">
      <div class="page-header"><span class="fa fa-file-text-o"></span>Quote:</div>
    </div>

    <div class="content" style="padding-bottom: 30px;">

      <div>
        <div class="product-search">
          <p-autoComplete #productSearchComponent [(ngModel)]="productSearch" field="SKU"
                          [suggestions]="searchResult"
                          placeholder="{{'bikeshop.modal.update_job_card.quote.search_sku_or_other' | translate }}"
                          (completeMethod)="searchProducts($event)" (onSelect)="addLineItemAuto($event)"
                          [disabled]="editing">
            <ng-template let-product pTemplate="item">
              <div>
                <span>{{ product.SKU }} - {{ product.Name }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <span class="hubtiger-search"></span>
        </div>

        <div class="quote-table margin-top-16">
          <div class="row header">
            <div class="col-md-2">
              {{ "bikeshop.modal.update_job_card.quote.sku" | translate }}
            </div>
            <div class="col-md-3">
              {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
            </div>
            <div class="col-md-1 right" *ngIf="allowDiscount">
              <span>
                {{
                "bikeshop.modal.update_job_card.quote.discount" | translate
                }}
              </span>
            </div>
            <div class="col-md-1 right" *ngIf="!allowDiscount"></div>
            <div class="col-md-1 right">
              {{ "bikeshop.modal.update_job_card.quote.qty" | translate }}
            </div>
            <div class="col-md-2 right" *ngIf="!VATInclusive">
              {{ "bikeshop.modal.update_job_card.quote.unit_price" | translate }}
            </div>
            <div class="col-md-2 right" *ngIf="VATInclusive">
              <span>
                {{
                "bikeshop.modal.update_job_card.quote.price_incl_vat" | translate
                }}
              </span>
            </div>
            <!--<div class="col-md-2 right">
              {{ "bikeshop.modal.update_job_card.quote.amount_ex_vat" | translate }}
            </div>-->
            <!--<div class="col-md-2 actions">
              <span class="fa fa-fw fa-plus"
                    *ngIf="!editing"
                    (click)="addLineItem()"
                    title="{{
                  'bikeshop.modal.update_job_card.quote.add_new_line_item_to_quote'
                    | translate
                }}"></span>
              <span class="fa fa-spinner fa-pulse" *ngIf="updatingQuote"></span>
            </div>-->
          </div>

          <div *ngFor="let lineItem of invoice.LineItems; let i = index">
            <div *ngIf="!lineItem.edit" class="row line-item">
              <div class="col-md-2">
                <span class="fa fa-circle item-synced" *ngIf="invoice.ExternalKey != null" [ngClass]="{
              'item-not-synced':
                (lineItem.ExternalKey === null ||
                  lineItem.ExternalKey === '') &&
                invoice.ExternalKey != null
            }"></span>{{ lineItem.SKU }}
              </div>
              <div class="col-md-3">
                {{
                lineItem.SKU === lineItem.Name
                  ? lineItem.Description
                  : lineItem.Name
                }}
              </div>
              <div class="col-md-1 right" *ngIf="allowDiscount">
                {{ invoice.CurrencySymbol }}
                {{ (lineItem.Discount ? lineItem.Discount : 0) | number: ".2-2" }}
              </div>
              <div class="col-md-1 right" *ngIf="!allowDiscount"></div>
              <div class="col-md-1 right">
                <p-inplace #qty (click)="editLineItem(i)">
                  <span pInplaceDisplay>
                    {{ lineItem.Quantity }}
                  </span>
                  <span pInplaceContent>
                    <div class="p-inputgroup">
                      <input type="number" min="0" pInputText [(ngModel)]="editLine.Quantity" #qty
                             (keyup.enter)="updateLine(i)" placeholder="{{
                    'bikeshop.modal.update_job_card.quote.qty' | translate
                  }}"/>
                    </div>
                  </span>
                </p-inplace>
              </div>
              <div class="col-md-2 right" *ngIf="!VATInclusive">
                {{ invoice.CurrencySymbol }} {{ lineItem.UnitPrice | number: ".2-2" }}
              </div>
              <div class="col-md-2 right" *ngIf="VATInclusive">
                <span *ngIf="VATInclusive">
                  {{ invoice.CurrencySymbol }}
                  {{ lineItem.UnitPrice_IncludingTax | number: ".2-2" }}
                </span>
              </div>
              <!--<div class="col-md-2 right">
                {{ invoice.CurrencySymbol }} {{ lineItem.Price | number: ".2-2" }}
              </div>-->
              <div class="col-md-2 actions">
                <span class="fa hubtiger-edit" (click)="editLineItem(i)" *ngIf="!editing"
                      title="Edit line item."></span>
                <span class="fa hubtiger-delete" (click)="deleteLineItem(i)" *ngIf="!editing" title="{{
              'bikeshop.modal.update_job_card.quote.delete_line_item_from_quote'
                | translate
            }}"></span>
              </div>
            </div>
            <div></div>
            <div *ngIf="lineItem.edit" class="row line-item edit">
              <div class="col-md-2">
                <p-autoComplete #lineItemProductSearchComponent [(ngModel)]="editLine" field="SKU"
                                [suggestions]="searchResult" placeholder="{{
              'bikeshop.modal.update_job_card.quote.enter_sku_or_name'
                | translate
            }}" (completeMethod)="searchProducts($event)">
                  <ng-template let-product pTemplate="item">
                    <div>
                      <span>{{ product.SKU }} - {{ product.Name }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="col-md-3">{{ editLine.Name }}</div>
              <div class="col-md-1 right"></div>
              <div class="col-md-1 right">
                <input type="number" min="0" pInputText [(ngModel)]="editLine.Quantity"
                       #quantityComponent
                       (keyup.enter)="updateLine(i)"
                       placeholder="{{ 'bikeshop.modal.update_job_card.quote.qty' | translate }}"/>
              </div>
              <div class="col-md-2 right">
                <span *ngIf="editLine.UnitPrice > 0">
                  {{ invoice.CurrencySymbol }}
                  {{ (VATInclusive ? editLine.UnitPrice_IncludingTax : editLine.UnitPrice) | number: ".2-2"  }}
                </span>
                <input *ngIf="editLine.OriginalUnitPrice === 0 || editLine.UnitPrice === 0"
                       type="number" pInputText
                       [(ngModel)]="editLine.UnitPrice" placeholder="{{
              'bikeshop.modal.update_job_card.quote.unit_price' | translate
            }}" style="text-align: right;margin-right: -16px;"/>
              </div>
              <!--<div class="col-md-1" *ngIf="allowDiscount">
    <div *ngIf="discountType === 'AMOUNT'">
      <input type="number" pInputText [(ngModel)]="editLine.Discount" />
    </div>
    <div class="p-inputgroup" *ngIf="discountType === 'PERCENTAGE'">
      <p-dropdown [options]="discounts"
                  class="full-width"
                  [(ngModel)]="editLine.DiscountID"></p-dropdown>
    </div>
  </div>-->


              <!--<div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ editLine.Quantity * editLine.UnitPrice | number: ".2-2" }}
              </div>-->
              <div class="col-md-2 actions">
                <span class="save" *ngIf="editLine.UnitPrice >= 0"
                      (click)="updateLine(i)">{{ "bikeshop.general.save" | translate }}</span>
              </div>
            </div>
          </div>

          <div class="totals" style="padding-top:20px;">
            <!--<div class="row" *ngIf="allowDiscount">
              <div class="col-md-6"></div>
              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.discount" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_Discounts | number: ".2-2" }}
              </div>
            </div>-->
            <div class="row">


              <div class="col-md-5"></div>


              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.sub-total" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_LineItems | number: ".2-2" }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-5"></div>
              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.vat" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_Tax | number: ".2-2" }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-5"></div>
              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.total" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_Price | number: ".2-2" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="container-fluid">

    <div class="header-container">
      <div class="page-header"><span class="fa fa-file-text-o"></span>Messages:</div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div id="notification-container" class="notification-container">
          <div *ngIf="messages == undefined">
            There are no notifications for this claim
          </div>
          <div *ngIf="messages == undefined">
            <div *ngIf="messages.length===0">
              There are no notifications for this claim
            </div>
          </div>
          <div class="notification" *ngFor="let notification of messages">
            <div
              [ngClass]="{'bike-shop': notification.Direction==='Outgoing', 'cyclist': notification.Direction==='Incoming'}">
              <div class="cyclist-name"
                   *ngIf="notification.Direction==='Incoming'">{{notification.To}}</div>
              <div class="cyclist-name"
                   *ngIf="notification.Direction==='outbound-api'">{{notification.Type}}</div>
              <div>{{notification.Message}}</div>
              <!--<div class="date">Sent to {{notification.To}}</div>-->
              <div class="date">{{notification.CreatedDate | date : 'medium'}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-12">
        <div class="p-inputgroup">
          <input type="text" pInputText [(ngModel)]="message"
                 placeholder="Add the message to the customer here" (keyup.enter)="sendMessage()"
                 [disabled]="sending"/>
          <span class="send-icon" (click)="sendMessage()" [ngClass]="{'sending': sending}"></span>
        </div>
      </div>
    </div>
  </div>
</p-sidebar>


<!--<p-sidebar [(visible)]="showQuote" [fullScreen]="true" [baseZIndex]="10000" [showCloseIcon]="true" >
  <div class="container-fluid">
    <div class="header-container">
      <div class="page-header"><span class="fa fa-file-text-o"></span>Information for claim: </div>
    </div>

    <div class="content" style="padding-bottom: 30px;">

      <div>
        <div class="product-search">
          <p-autoComplete #productSearchComponent
                          [(ngModel)]="productSearch"
                          field="SKU"
                          [suggestions]="searchResult"
                          placeholder="{{'bikeshop.modal.update_job_card.quote.search_sku_or_other' | translate }}"
                          (completeMethod)="searchProducts($event)"
                          (onSelect)="addLineItemAuto($event)"
                          [disabled]="editing">
            <ng-template let-product pTemplate="item">
              <div>
                <span>{{ product.SKU }} - {{ product.Name }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <span class="fa fa-search"></span>
        </div>

        <div class="quote-table">
          <div class="row header">
            <div class="col-md-2">
              {{ "bikeshop.modal.update_job_card.quote.sku" | translate }}
            </div>
            <div class="col-md-3">
              {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
            </div>
            <div class="col-md-1 right" *ngIf="!VATInclusive">
              {{ "bikeshop.modal.update_job_card.quote.unit_price" | translate }}
            </div>
            <div class="col-md-1 right" *ngIf="VATInclusive">
              <span>
                {{
          "bikeshop.modal.update_job_card.quote.price_incl_vat" | translate
                }}
              </span>
            </div>
            <div class="col-md-1 right" *ngIf="allowDiscount">
              <span>
                {{
          "bikeshop.modal.update_job_card.quote.discount" | translate
                }}
              </span>
            </div>
            <div class="col-md-1 right" *ngIf="!allowDiscount"></div>
            <div class="col-md-1 right">
              {{ "bikeshop.modal.update_job_card.quote.qty" | translate }}
            </div>
            <div class="col-md-2 right">
              {{ "bikeshop.modal.update_job_card.quote.amount_ex_vat" | translate }}
            </div>
          </div>

          <div *ngFor="let lineItem of invoice.LineItems; let i = index">
            <div *ngIf="!lineItem.edit" class="row line-item">
              <div class="col-md-2">
                <span class="fa fa-circle item-synced"
                      *ngIf="isDev && invoice.ExternalKey != null"
                      [ngClass]="{
              'item-not-synced':
                (lineItem.ExternalKey === null ||
                  lineItem.ExternalKey === '') &&
                invoice.ExternalKey != null
            }"></span>{{ lineItem.SKU }}
              </div>
              <div class="col-md-3">
                {{
            lineItem.SKU === lineItem.Name
              ? lineItem.Description
              : lineItem.Name
                }}
              </div>
              <div class="col-md-1 right" *ngIf="!VATInclusive">
                {{ invoice.CurrencySymbol }} {{ lineItem.UnitPrice | number: ".2-2" }}
              </div>
              <div class="col-md-1 right" *ngIf="VATInclusive">
                <span *ngIf="VATInclusive">
                  {{ invoice.CurrencySymbol }}
                  {{ lineItem.UnitPrice_IncludingTax | number: ".2-2" }}
                </span>
              </div>
              <div class="col-md-1 right" *ngIf="allowDiscount">
                {{ invoice.CurrencySymbol }}
                {{ (lineItem.Discount ? lineItem.Discount : 0) | number: ".2-2" }}
              </div>
              <div class="col-md-1 right" *ngIf="!allowDiscount"></div>
              <div class="col-md-1 right">
                <p-inplace #qty (click)="editLineItem(i)">
                  <span pInplaceDisplay>
                    {{ lineItem.Quantity }}
                  </span>
                  <span pInplaceContent>
                    <div class="p-inputgroup">
                      <input type="number"
                             min="0"
                             pInputText
                             [(ngModel)]="editLine.Quantity"
                             #qty
                             (keyup.enter)="updateLine(i)"
                             placeholder="{{
                    'bikeshop.modal.update_job_card.quote.qty' | translate
                  }}" />
                    </div>
                  </span>
                </p-inplace>
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }} {{ lineItem.Price | number: ".2-2" }}
              </div>
              <div class="col-md-2 actions">
                <span class="fa fa-fw fa-pencil" (click)="editLineItem(i)" *ngIf="!editing" title="Edit line item."></span>
                <span class="fa fa-fw fa-trash-o" (click)="deleteLineItem(i)" *ngIf="!editing" title="{{
              'bikeshop.modal.update_job_card.quote.delete_line_item_from_quote'
                | translate
            }}"></span>
              </div>
            </div>
            <div></div>
            <div *ngIf="lineItem.edit" class="row line-item edit">
              <div class="col-md-2">
                <p-autoComplete #lineItemProductSearchComponent
                                [(ngModel)]="editLine"
                                field="SKU"
                                [suggestions]="searchResult"
                                placeholder="{{
              'bikeshop.modal.update_job_card.quote.enter_sku_or_name'
                | translate
            }}"
                                (completeMethod)="searchProducts($event)"
                                (onSelect)="skuSelected($event)">
                  <ng-template let-product pTemplate="item">
                    <div>
                      <span>{{ product.SKU }} - {{ product.Name }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
              <div class="col-md-2">{{ editLine.Name }}</div>
              <div class="col-md-2 right">
                <span *ngIf="editLine.Price > 0">
                  {{ invoice.CurrencySymbol }}
                  {{
              VATInclusive
                ? editLine.UnitPrice_IncludingTax
                : editLine.UnitPrice
                  }}
                </span>
                <input *ngIf="editLine.OriginalUnitPrice === 0 || editLine.Price === 0"
                       type="number"
                       pInputText
                       [(ngModel)]="editLine.UnitPrice"
                       placeholder="{{
              'bikeshop.modal.update_job_card.quote.unit_price' | translate
            }}"
                       style="text-align: right;margin-right: -16px;" />
              </div>
              <div class="col-md-1 right" *ngIf="!allowDiscount"></div>
              <div class="col-md-1 right">
                <input type="number"
                       min="0"
                       pInputText
                       [(ngModel)]="editLine.Quantity"
                       #quantityComponent
                       (keyup.enter)="updateLine(i)"
                       placeholder="{{
              'bikeshop.modal.update_job_card.quote.qty' | translate
            }}" />
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ editLine.Quantity * editLine.UnitPrice | number: ".2-2" }}
              </div>
              <div class="col-md-2 actions">
                <span class="fa fa-fw fa-check green"
                      *ngIf="editLine.UnitPrice >= 0"
                      (click)="updateLine(i)"
                      title="{{
              'bikeshop.modal.update_job_card.quote.save_line_item_and_update_quote'
                | translate
            }}"></span>
              </div>
            </div>
          </div>
          <div class="row line"
               *ngIf="invoice.LineItems && invoice.LineItems.length > 0"></div>

          <div class="totals" style="padding-top:20px;">
            <div class="row">


              <div class="col-md-6"></div>


              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.sub-total" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_LineItems | number: ".2-2" }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.vat" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_Tax | number: ".2-2" }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-2 right">
                {{ "bikeshop.modal.update_job_card.quote.total" | translate }}:
              </div>
              <div class="col-md-2 right">
                {{ invoice.CurrencySymbol }}
                {{ invoice.Total_Price | number: ".2-2" }}
              </div>
            </div>
          </div>


        </div>

      </div>


    </div>
  </div>
</p-sidebar>-->
